// Add CSS for form validation styling
const validationStyles = `
  .is-invalid {
    border-color: #dc3545 !important;
    box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25) !important;
  }
  
  .field-error {
    display: block;
    width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;
  }
  
  .form-message {
    border-radius: 0.375rem;
    padding: 0.75rem 1rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
  }
  
  .alert-danger {
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
  }
  
  .alert-success {
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
  }
`;

// Inject styles into the page
if (!document.getElementById('playhouse-validation-styles')) {
  const styleSheet = document.createElement('style');
  styleSheet.id = 'playhouse-validation-styles';
  styleSheet.textContent = validationStyles;
  document.head.appendChild(styleSheet);
}

// Phone validation patterns for different countries
const phonePatterns = {
    '+1': {
        pattern: /^[2-9]\d{2}[2-9]\d{2}\d{4}$/,
        format: '(XXX) XXX-XXXX',
        length: 10,
        name: 'USA/Canada'
    },
    '+7': {
        pattern: /^\d{10}$/,
        format: 'XXX XXX XXXX',
        length: 10,
        name: 'Russia'
    },
    '+20': {
        pattern: /^\d{8,10}$/,
        format: 'XX XXXX XXXX',
        length: [8, 10],
        name: 'Egypt'
    },
    '+27': {
        pattern: /^\d{9}$/,
        format: 'XX XXX XXXX',
        length: 9,
        name: 'South Africa'
    },
    '+31': {
        pattern: /^\d{9}$/,
        format: 'X XXXX XXXX',
        length: 9,
        name: 'Netherlands'
    },
    '+32': {
        pattern: /^\d{8,9}$/,
        format: 'XX XXX XXXX',
        length: [8, 9],
        name: 'Belgium'
    },
    '+33': {
        pattern: /^\d{9}$/,
        format: 'X XX XX XX XX',
        length: 9,
        name: 'France'
    },
    '+34': {
        pattern: /^\d{9}$/,
        format: 'XXX XXX XXX',
        length: 9,
        name: 'Spain'
    },
    '+39': {
        pattern: /^\d{9,10}$/,
        format: 'XXX XXX XXXX',
        length: [9, 10],
        name: 'Italy'
    },
    '+41': {
        pattern: /^\d{9}$/,
        format: 'XX XXX XXXX',
        length: 9,
        name: 'Switzerland'
    },
    '+43': {
        pattern: /^\d{10,11}$/,
        format: 'XXXX XXXXXX',
        length: [10, 11],
        name: 'Austria'
    },
    '+44': {
        pattern: /^\d{10,11}$/,
        format: 'XXXX XXX XXXX',
        length: [10, 11],
        name: 'UK'
    },
    '+45': {
        pattern: /^\d{8}$/,
        format: 'XX XX XX XX',
        length: 8,
        name: 'Denmark'
    },
    '+46': {
        pattern: /^\d{9}$/,
        format: 'XX XXX XXXX',
        length: 9,
        name: 'Sweden'
    },
    '+47': {
        pattern: /^\d{8}$/,
        format: 'XXX XX XXX',
        length: 8,
        name: 'Norway'
    },
    '+52': {
        pattern: /^\d{10}$/,
        format: 'XXX XXX XXXX',
        length: 10,
        name: 'Mexico'
    },
    '+55': {
        pattern: /^\d{10,11}$/,
        format: 'XX XXXXX XXXX',
        length: [10, 11],
        name: 'Brazil'
    },
    '+60': {
        pattern: /^\d{9,10}$/,
        format: 'XX XXXX XXXX',
        length: [9, 10],
        name: 'Malaysia'
    },
    '+61': {
        pattern: /^\d{9}$/,
        format: 'X XXXX XXXX',
        length: 9,
        name: 'Australia'
    },
    '+62': {
        pattern: /^\d{9,12}$/,
        format: 'XXX XXXX XXXX',
        length: [9, 12],
        name: 'Indonesia'
    },
    '+63': {
        pattern: /^\d{10}$/,
        format: 'XXX XXX XXXX',
        length: 10,
        name: 'Philippines'
    },
    '+64': {
        pattern: /^\d{8,9}$/,
        format: 'XX XXX XXXX',
        length: [8, 9],
        name: 'New Zealand'
    },
    '+65': {
        pattern: /^\d{8}$/,
        format: 'XXXX XXXX',
        length: 8,
        name: 'Singapore'
    },
    '+66': {
        pattern: /^\d{9}$/,
        format: 'XX XXX XXXX',
        length: 9,
        name: 'Thailand'
    },
    '+81': {
        pattern: /^\d{10,11}$/,
        format: 'XX XXXX XXXX',
        length: [10, 11],
        name: 'Japan'
    },
    '+82': {
        pattern: /^\d{9,11}$/,
        format: 'XX XXXX XXXX',
        length: [9, 11],
        name: 'South Korea'
    },
    '+84': {
        pattern: /^\d{9,10}$/,
        format: 'XXX XXX XXXX',
        length: [9, 10],
        name: 'Vietnam'
    },
    '+86': {
        pattern: /^\d{11}$/,
        format: 'XXX XXXX XXXX',
        length: 11,
        name: 'China'
    },
    '+91': {
        pattern: /^[6-9]\d{9}$/,
        format: 'XXXXX XXXXX',
        length: 10,
        name: 'India'
    },
    '+358': {
        pattern: /^\d{9}$/,
        format: 'XX XXX XXXX',
        length: 9,
        name: 'Finland'
    },
    '+966': {
        pattern: /^\d{9}$/,
        format: 'XX XXX XXXX',
        length: 9,
        name: 'Saudi Arabia'
    },
    '+971': {
        pattern: /^\d{9}$/,
        format: 'XX XXX XXXX',
        length: 9,
        name: 'UAE'
    }
};

class PlayhouseSupport {
  constructor(options = {}) {
    this.areaCodeSelect = null;
    this.phoneInput = null;
    this.errorDiv = null;
    this.form = null;
    this.validationErrors = {};
    
    // File accumulation for multiple file inputs
    this.accumulatedFiles = {};
    
    // API Configuration
    this.apiConfig = {
      uploadUrl: options.uploadUrl || 'https://formbuilder.hulkapps.com/forms/file_upload/2_hkLenGtncJKXg2C-GQ-A',
      submitUrl: options.submitUrl || 'https://formbuilder.hulkapps.com/forms/create_response/ZaCP6KLggeteDUFHgxCrzw',
      accessToken: options.accessToken || '6003ad618bdb6a61'
    };
    
    this.init();
  }

  init() {
    
    // Get form reference
    this.form = document.querySelector('.outdoor-form');
    
    if (!this.form) {
      return;
    }
    
    // Initialize Country/Province selector
    if (typeof Shopify !== 'undefined' && Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
        hideElement: "AddressProvinceContainerNew"
      });
      
      // Filter out unwanted states/territories after initialization
      setTimeout(() => {
        this.filterUnwantedStates();
      }, 100);
      
      // Add event listener for country changes to refilter states
      const countrySelect = document.getElementById('AddressCountryNew');
      if (countrySelect) {
        countrySelect.addEventListener('change', () => {
          setTimeout(() => {
            this.filterUnwantedStates();
          }, 100);
        });
      }
    }
    
    // Initialize phone validation
    this.initPhoneValidation();
    
    // Initialize form validation and submission
    this.initFormValidation();
    this.initFormSubmission();
    
    // Initialize file input feedback
    this.initFileInputFeedback();
  }

  initPhoneValidation() {
    this.areaCodeSelect = document.getElementById('areaCodeSelect');
    this.phoneInput = document.getElementById('phoneNumber');
    this.errorDiv = document.getElementById('phoneError');
    
    if (!this.areaCodeSelect || !this.phoneInput || !this.errorDiv) {
      return; // Elements not found, skip phone validation
    }

    
    // Set initial placeholder for default USA selection
    this.setPlaceholder();
    this.bindPhoneEvents();
  }

  setPlaceholder() {
    const selectedCode = this.areaCodeSelect.value;
    if (selectedCode && phonePatterns[selectedCode]) {
      this.phoneInput.placeholder = `Enter ${phonePatterns[selectedCode].name} phone number`;
    } else {
      this.phoneInput.placeholder = 'Enter phone number';
    }
  }

  validatePhone() {
    const areaCode = this.areaCodeSelect.value;
    const phoneNumber = this.phoneInput.value.replace(/\D/g, ''); // Remove non-digits
    
    if (!areaCode) {
      this.showError('Please select an area code');
      return false;
    }
    
    if (!phoneNumber) {
      this.showError('Please enter a phone number');
      return false;
    }
    
    const pattern = phonePatterns[areaCode];
    if (pattern) {
      const isValidLength = Array.isArray(pattern.length) 
        ? pattern.length.includes(phoneNumber.length)
        : phoneNumber.length === pattern.length;
        
      if (!isValidLength) {
        const lengthText = Array.isArray(pattern.length) 
          ? pattern.length.join(' or ') + ' digits'
          : pattern.length + ' digits';
        this.showError(`${pattern.name} phone numbers must be ${lengthText}`);
        return false;
      }
      
      if (!pattern.pattern.test(phoneNumber)) {
        this.showError(`Invalid ${pattern.name} phone number format. Expected: ${pattern.format}`);
        return false;
      }
    } else {
      // Generic validation for countries not in patterns
      if (phoneNumber.length < 7 || phoneNumber.length > 15) {
        this.showError('Phone number must be between 7 and 15 digits');
        return false;
      }
    }
    
    this.hideError();
    return true;
  }

  showError(message) {
    this.errorDiv.textContent = message;
    this.errorDiv.style.display = 'block';
    this.phoneInput.classList.add('is-invalid');
  }

  hideError() {
    this.errorDiv.style.display = 'none';
    this.phoneInput.classList.remove('is-invalid');
  }

  filterUnwantedStates() {
    const provinceSelect = document.getElementById('AddressProvinceNew');
    if (!provinceSelect) return;

    // States and territories to remove
    const unwantedStates = [
      'Alaska',
      'American Samoa', 
      'Hawaii',
      'Guam',
      'Marshall Islands',
      'Northern Mariana Islands',
      'Federated States of Micronesia',
      'Palau',
      'Puerto Rico',
      'Virgin Islands',
      'U.S. Virgin Islands'
    ];

    // Remove unwanted options
    const options = Array.from(provinceSelect.options);
    options.forEach(option => {
      if (unwantedStates.includes(option.value) || unwantedStates.includes(option.textContent)) {
        option.remove();
      }
    });
  }

  formatPhoneNumber() {
    if (!this.areaCodeSelect || !this.phoneInput) return;
    
    const areaCode = this.areaCodeSelect.value;
    let phoneNumber = this.phoneInput.value.replace(/\D/g, '');
    
    if (areaCode === '+1' && phoneNumber.length === 10) {
      // Format US/Canada numbers as (XXX) XXX-XXXX
      phoneNumber = phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      this.phoneInput.value = phoneNumber;
    }
  }

  initFormValidation() {
    if (!this.form) {
      return;
    }
    
    try {
      // Add real-time validation to all required fields
      const requiredFields = this.form.querySelectorAll('[required]');
      requiredFields.forEach(field => {
        if (field && typeof field.addEventListener === 'function') {
          field.addEventListener('blur', () => this.validateField(field));
          field.addEventListener('input', () => this.clearFieldError(field));
        }
      });
      
      // Add specific validation for date fields
      const dateFields = ['purchaseMonth', 'purchaseDay', 'purchaseYear'];
      dateFields.forEach(fieldId => {
        const field = document.getElementById(fieldId);
        if (field && typeof field.addEventListener === 'function') {
          field.addEventListener('blur', () => this.validateDateField(field));
          field.addEventListener('input', () => this.clearFieldError(field));
        }
      });
    } catch (error) {
      console.error('Error initializing form validation:', error);
    }
  }

  initFormSubmission() {
    if (!this.form) return;
    
    // Handle form submit event
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleFormSubmission();
    });
    
    // Also handle submit button click as backup
    const submitButton = this.form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleFormSubmission();
      });
    }
  }

  validateField(field) {
    const fieldId = field.id;
    const fieldValue = field.value.trim();
    const isRequired = field.hasAttribute('required');
    
    // Check if required field is empty
    if (isRequired && !fieldValue) {
      this.showFieldError(field, 'This field is required.');
      return false;
    }
    
    // If field has value, clear any previous errors
    if (fieldValue) {
      this.clearFieldError(field);
    }
    
    // Specific validations based on field type
    switch (field.type) {
      case 'email':
        return this.validateEmail(field);
      case 'tel':
        return this.validatePhone();
      case 'number':
        return this.validateNumber(field);
      case 'file':
        return this.validateFile(field);
      default:
        return true;
    }
  }

  validateEmail(field) {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (field.value && !emailPattern.test(field.value)) {
      this.showFieldError(field, 'Please enter a valid email address.');
      return false;
    }
    return true;
  }

  validateNumber(field) {
    const value = parseInt(field.value);
    const min = parseInt(field.getAttribute('min'));
    const max = parseInt(field.getAttribute('max'));
    
    if (field.value && isNaN(value)) {
      this.showFieldError(field, 'Please enter a valid number.');
      return false;
    }
    
    if (min !== null && value < min) {
      this.showFieldError(field, `Value must be at least ${min}.`);
      return false;
    }
    
    if (max !== null && value > max) {
      this.showFieldError(field, `Value must be no more than ${max}.`);
      return false;
    }
    
    return true;
  }

  validateFile(field) {
    if (field.hasAttribute('required') && field.files.length === 0) {
      this.showFieldError(field, 'Please select a file.');
      return false;
    }
    
    // Check for video files
    if (field.files.length > 0) {
      for (let i = 0; i < field.files.length; i++) {
        const file = field.files[i];
        if (this.isVideoFile(file)) {
          this.showFieldError(field, 'Video files are not allowed. Please select images or documents only.');
          return false;
        }
      }
    }
    
    return true;
  }

  validateDateField(field) {
    const fieldId = field.id;
    const value = field.value.trim();
    
    if (!value && field.hasAttribute('required')) {
      this.showFieldError(field, 'This field is required.');
      return false;
    }
    
    if (!value) return true; // Optional field, empty is OK
    
    const numValue = parseInt(value);
    
    switch (fieldId) {
      case 'purchaseMonth':
        if (numValue < 1 || numValue > 12) {
          this.showFieldError(field, 'Month must be between 1 and 12.');
          return false;
        }
        break;
      case 'purchaseDay':
        if (numValue < 1 || numValue > 31) {
          this.showFieldError(field, 'Day must be between 1 and 31.');
          return false;
        }
        break;
      case 'purchaseYear':
        const currentYear = new Date().getFullYear();
        if (numValue < 1900 || numValue > currentYear) {
          this.showFieldError(field, `Year must be between 1900 and ${currentYear}.`);
          return false;
        }
        break;
    }
    
    // Validate complete date if all three fields have values
    this.validateCompleteDate();
    return true;
  }

  validateCompleteDate() {
    const monthField = document.getElementById('purchaseMonth');
    const dayField = document.getElementById('purchaseDay');
    const yearField = document.getElementById('purchaseYear');
    
    if (!monthField || !dayField || !yearField) return true;
    
    const month = parseInt(monthField.value);
    const day = parseInt(dayField.value);
    const year = parseInt(yearField.value);
    
    // Only validate if all fields have values
    if (!month || !day || !year) return true;
    
    // Check if the date is valid
    const date = new Date(year, month - 1, day);
    const isValidDate = date.getFullYear() === year && 
                       date.getMonth() === month - 1 && 
                       date.getDate() === day;
    
    if (!isValidDate) {
      this.showFieldError(dayField, 'Please enter a valid date.');
      return false;
    }
    
    // Check if date is not in the future
    const today = new Date();
    if (date > today) {
      this.showFieldError(dayField, 'Purchase date cannot be in the future.');
      return false;
    }
    
    return true;
  }

  showFieldError(field, message) {
    this.clearFieldError(field);
    
    // Create error element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'field-error text-danger small mt-1';
    errorDiv.textContent = message;
    errorDiv.setAttribute('data-field-error', field.id);
    
    // Insert error after the field
    field.parentNode.insertBefore(errorDiv, field.nextSibling);
    
    // Add error styling to field
    field.classList.add('is-invalid');
    
    // Store error
    this.validationErrors[field.id] = message;
  }

  clearFieldError(field) {
    // Remove error element
    const existingError = field.parentNode.querySelector(`[data-field-error="${field.id}"]`);
    if (existingError) {
      existingError.remove();
    }
    
    // Remove error styling
    field.classList.remove('is-invalid');
    
    // Remove from errors object
    delete this.validationErrors[field.id];
  }

  validateAllFields() {
    let isValid = true;
    this.validationErrors = {};
    
    // Clear all existing validation states first
    this.clearAllValidationStates();
    
    // Validate all required fields
    const requiredFields = this.form.querySelectorAll('[required]');
    
    requiredFields.forEach(field => {
      if (!this.validateField(field)) {
        isValid = false;
      }
    });
    
    // Validate date fields specifically
    const dateFields = ['purchaseMonth', 'purchaseDay', 'purchaseYear'];
    dateFields.forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field && !this.validateDateField(field)) {
        isValid = false;
      }
    });

    return isValid;
  }

  handleFormSubmission() {

    
    // Validate all fields
    const isValid = this.validateAllFields();
    
    if (!isValid) {
      
      // Focus on first error field
      const firstErrorField = this.form.querySelector('.is-invalid');
      if (firstErrorField) {
        firstErrorField.focus();
        firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      
      // Don't show summary error message - individual field errors are enough
      return false;
    }

    
    // Collect form data
    const formData = this.collectFormData();
    
    // Submit form
    this.submitForm(formData);
    return false;
  }

  collectFormData() {
    if (!this.form) {
      throw new Error('Form element not found');
    }

    const formData = new FormData(this.form);
    const requestData = {};

    // Map form fields to API field names according to the required format
    const fieldMapping = {
      'first_name': 'First Name',
      'last_name': 'Last Name',
      'email': 'Email Address',
      'area_code': 'Area Code',
      'phone_number': 'Phone Number',
      'address_1': 'Address 1',
      'address_2': 'Address 2',
      'city': 'City',
      'address[province]': 'State',
      'zip_code': 'Zip Code',
      'address[country]': 'Country',
      'batch_code': 'Batch Code',
      'plaque_id': 'Plaque ID',
      'model_name': 'Model Name',
      'model_number': 'Model Number',
      'purchase_month': 'Purchase Month',
      'purchase_day': 'Purchase Day',
      'purchase_year': 'Purchase Year',
      'purchased_from': 'Purchased From',
      'order_number': 'Order Number',
      'part_number_1': 'Part Number',
      'part_description_1': 'Part Description',
      'quantity_1': 'Quantity',
      'reason_1': 'Reason of Replacement',
      'part_number_2': 'Second Part Number',
      'part_description_2': 'Second Part Description',
      'quantity_2': 'Second Part Quantity',
      'reason_2': 'Second Part Reason of Replacement',
      'part_number_3': 'Third Part Number',
      'part_description_3': 'Third Part Description',
      'quantity_3': 'Third Part Quantity',
      'reason_3': 'Third Part Reason of Replacement',
      'additional_notes': 'Additional Comments'
    };

    // Process form data
    for (let [key, value] of formData.entries()) {
      if (key.startsWith('proof_') || key === 'proof_purchase' || key === 'proof_final') {
        // Skip file inputs - they'll be handled separately
        continue;
      }
      
      const apiFieldName = fieldMapping[key] || key;
      
      if (value && value.trim() !== '') {
        requestData[apiFieldName] = value.trim();
      }
    }

    // Combine date fields into a single date string
    const month = requestData['Purchase Month'];
    const day = requestData['Purchase Day'];
    const year = requestData['Purchase Year'];
    
    if (month && day && year) {
      // Format as YYYY-MM-DD
      const formattedMonth = month.padStart(2, '0');
      const formattedDay = day.padStart(2, '0');
      requestData['Date of Purchase'] = `${year}-${formattedMonth}-${formattedDay}`;
      
      // Remove individual date fields
      delete requestData['Purchase Month'];
      delete requestData['Purchase Day'];
      delete requestData['Purchase Year'];
    }

    // Combine area code and phone number
    const areaCode = requestData['Area Code'];
    const phoneNumber = requestData['Phone Number'];
    if (areaCode && phoneNumber) {
      requestData['Phone Number'] = `${areaCode} ${phoneNumber}`;
      delete requestData['Area Code'];
    }

    return requestData;
  }

  createFormDataForUpload() {
    if (!this.form) {
      throw new Error('Form element not found');
    }
    
    const formData = new FormData(this.form);
    return formData;
  }

  async uploadFile(formData, fileInputId) {
    
    const response = await fetch(this.apiConfig.uploadUrl, {
      method: "POST",
      headers: {
        "X-Form-Access-Token": this.apiConfig.accessToken
      },
      body: formData
    });

    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  }

  async uploadAllFiles() {
    const fileUploads = {};
    const fileInputs = [
      { id: 'proof', name: 'Proof of Purchase', multiple: false },
      { id: 'proof1', name: 'Part Proof of Damage', multiple: false },
      { id: 'proof2', name: 'Second Part File', multiple: false },
      { id: 'proof3', name: 'Third Part File', multiple: false },
      { id: 'proof_final', name: 'Additional Photos', multiple: true }
    ];

    for (const fileInput of fileInputs) {
      const input = document.getElementById(fileInput.id);
      
      try {
        if (fileInput.multiple && fileInput.id === 'proof_final' && this.accumulatedFiles[fileInput.id]) {
          // Handle accumulated multiple files for proof_final
          const accumulatedFiles = this.accumulatedFiles[fileInput.id];
          
          const uploadedFiles = [];
          for (let i = 0; i < accumulatedFiles.length; i++) {
            const formData = new FormData();
            formData.append("file_data", accumulatedFiles[i]);
            
            const uploadResponse = await this.uploadFile(formData, `${fileInput.id}_${i}`);
            
            if (!uploadResponse.error && uploadResponse.response && uploadResponse.response.url) {
              uploadedFiles.push({
                url: uploadResponse.response.url,
                type: "file"
              });
            }
          }
          
          if (uploadedFiles.length > 0) {
            fileUploads[fileInput.name] = {
              type: "file",
              upload_type: "multiple",
              files: uploadedFiles
            };

          }
        } else if (input && input.files && input.files.length > 0) {
          // Handle single file inputs
          const formData = new FormData();
          formData.append("file_data", input.files[0]);
          
          const uploadResponse = await this.uploadFile(formData, fileInput.id);
          
          if (!uploadResponse.error && uploadResponse.response && uploadResponse.response.url) {
            fileUploads[fileInput.name] = {
              type: "file",
              url: uploadResponse.response.url
            };
          }
        }
      } catch (error) {
        console.error(`Error uploading file ${fileInput.id}:`, error);
        // Continue with other files even if one fails
      }
    }

    return fileUploads;
  }

  async submitFormData(requestData) {
    const jsonData = JSON.stringify({ formResponse: requestData });

    
    const response = await fetch(this.apiConfig.submitUrl, {
      method: "POST",
      headers: {
        "X-Form-Access-Token": this.apiConfig.accessToken,
        "Content-Type": "application/json",
        "accept": "application/json"
      },
      body: jsonData
    });
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    return await response.json();
  }

  async submitForm(formData) {

    
    try {
      // Show loading state
      this.showFormLoading(true);

      const fileUploads = await this.uploadAllFiles();

      
      // Collect form data
      const requestData = this.collectFormData();
      
      // Add file uploads to request data
      Object.assign(requestData, fileUploads);
      

      
      // Submit form data
      const result = await this.submitFormData(requestData);

      
      this.showFormLoading(false);
      this.showFormSuccess('Your playhouse support request has been submitted successfully!');
      
      // Show success section and hide form sections after a short delay
      setTimeout(() => {
        this.toggleSectionsOnSuccess();
      }, 1000);
      
      // Optional: Reset form after successful submission
      // this.form.reset();
      // this.clearAllErrors();
      
    } catch (error) {
      this.showFormLoading(false);
      this.showFormError('Something went wrong while submitting your request. Please try again.');
    }
  }

  showFormLoading(show) {
    const submitButton = this.form.querySelector('button[type="submit"]');
    if (!submitButton) return;
    
    if (show) {
      submitButton.disabled = true;
      submitButton.textContent = 'Submitting...';
    } else {
      submitButton.disabled = false;
      submitButton.textContent = 'Submit Order Form';
    }
  }

  showFormError(message) {
    this.clearFormMessages();
    const messageDiv = this.createFormMessage(message, 'error');
    this.form.insertBefore(messageDiv, this.form.firstChild);
  }

  showFormSuccess(message) {
    this.clearFormMessages();
    const messageDiv = this.createFormMessage(message, 'success');
    this.form.insertBefore(messageDiv, this.form.firstChild);
  }

  createFormMessage(message, type) {
    const messageDiv = document.createElement('div');
    messageDiv.className = `form-message alert ${type === 'error' ? 'alert-danger' : 'alert-success'} mb-4`;
    messageDiv.textContent = message;
    return messageDiv;
  }

  clearFormMessages() {
    const existingMessages = this.form.querySelectorAll('.form-message');
    existingMessages.forEach(msg => msg.remove());
  }

  clearAllErrors() {
    Object.keys(this.validationErrors).forEach(fieldId => {
      const field = document.getElementById(fieldId);
      if (field) {
        this.clearFieldError(field);
      }
    });
  }

  clearAllValidationStates() {
    // Clear all validation states from all form fields
    const allFields = this.form.querySelectorAll('input, select, textarea');
    allFields.forEach(field => {
      // Remove invalid class
      field.classList.remove('is-invalid');
      
      // Remove any existing error messages
      const existingError = field.parentNode.querySelector(`[data-field-error="${field.id}"]`);
      if (existingError) {
        existingError.remove();
      }
    });
  }

  bindPhoneEvents() {
    
    // Input event listener
    this.phoneInput.addEventListener('input', () => {
      // Remove non-numeric characters except spaces, dashes, parentheses
      this.phoneInput.value = this.phoneInput.value.replace(/[^\d\s\-\(\)]/g, '');
      this.validatePhone();
    });
    
    // Blur event listener
    this.phoneInput.addEventListener('blur', () => {
      this.formatPhoneNumber();
      this.validatePhone();
    });
    
    // Area code change event listener
    this.areaCodeSelect.addEventListener('change', () => {
      this.setPlaceholder();
      if (this.phoneInput.value) {
        this.validatePhone();
      }
    });
    
    // Phone validation is now handled by the main form validation system
  }

  initFileInputFeedback() {
    if (!this.form) {
      return;
    }
    
    try {
      // Find all file input elements
      const fileInputs = this.form.querySelectorAll('input[type="file"]');
      
      fileInputs.forEach(input => {
        if (input && typeof input.addEventListener === 'function') {
          input.addEventListener('change', (event) => {
            this.handleFileSelection(event.target);
          });
          
          // Also add a click event to see when the file dialog opens
          input.addEventListener('click', (event) => {

          });
        }
      });
      
      // Find all remove buttons and add event listeners
      const removeButtons = this.form.querySelectorAll('.file-remove-btn');
      removeButtons.forEach(button => {
        if (button && typeof button.addEventListener === 'function') {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            const targetId = event.target.getAttribute('data-target');
            if (targetId) {
              this.handleFileRemoval(targetId);
            }
          });
        }
      });
      
      // Find all "Add file" buttons and make them clickable
      const addFileButtons = this.form.querySelectorAll('.proof-file-btn');
      addFileButtons.forEach(button => {
        if (button && typeof button.addEventListener === 'function') {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            const dropzone = button.closest('.proof-dropzone');
            if (dropzone) {
              const fileInput = dropzone.querySelector('input[type="file"]');
              if (fileInput && typeof fileInput.click === 'function') {
                // Debug: Log if this is a multiple file input
                if (fileInput.hasAttribute('multiple')) {

                }
                // Ensure the file input is properly focused and clicked
                fileInput.focus();
                fileInput.click();
              }
            }
          });
        }
      });
      
      // Also add click handler to the dropzone itself for better UX
      const dropzones = this.form.querySelectorAll('.proof-dropzone');
      dropzones.forEach(dropzone => {
        if (dropzone && typeof dropzone.addEventListener === 'function') {
          dropzone.addEventListener('click', (event) => {
            // Only trigger if clicking on the dropzone itself, not on buttons
            if (event.target === dropzone) {
              const fileInput = dropzone.querySelector('input[type="file"]');
              if (fileInput && typeof fileInput.click === 'function') {
                if (fileInput.hasAttribute('multiple')) {
                  
                }
                fileInput.focus();
                fileInput.click();
              }
            }
          });
        }
      });
      
    } catch (error) {
      console.error('Error initializing file input feedback:', error);
    }
  }

  handleFileSelection(fileInput) {
    const dropzone = fileInput.closest('.proof-dropzone');
    const infoDiv = dropzone.querySelector('.file-selected-info');
    
    if (!dropzone || !infoDiv) {
      return;
    }
    
    const files = fileInput.files;
    
    if (files && files.length > 0) {
      // Check for video files first
      let hasVideoFile = false;
      for (let i = 0; i < files.length; i++) {
        if (this.isVideoFile(files[i])) {
          hasVideoFile = true;
          break;
        }
      }
      
      if (hasVideoFile) {
        // Clear the input and show error
        fileInput.value = '';
        dropzone.classList.remove('has-file');
        infoDiv.innerHTML = '';
        this.showFieldError(fileInput, 'Video files are not allowed. Please select images or documents only.');
        return;
      }
      
      // Handle multiple file accumulation for proof_final
      if (fileInput.hasAttribute('multiple') && fileInput.id === 'proof_final') {
        this.handleMultipleFileAccumulation(fileInput, files, dropzone, infoDiv);
      } else {
        // Handle single file inputs normally
        dropzone.classList.add('has-file');
        this.clearFieldError(fileInput);
        
        const fileName = files[0].name;
        const fileSize = this.formatFileSize(files[0].size);
        infoDiv.innerHTML = `<strong>Selected:</strong><br>${fileName}<br><small>(${fileSize})</small>`;
      }
    } else {
      // No file selected
      dropzone.classList.remove('has-file');
      infoDiv.innerHTML = '';
      if (fileInput.hasAttribute('multiple')) {
        delete this.accumulatedFiles[fileInput.id];
      }
    }
  }

  handleMultipleFileAccumulation(fileInput, newFiles, dropzone, infoDiv) {
    // Initialize accumulated files array for this input if it doesn't exist
    if (!this.accumulatedFiles[fileInput.id]) {
      this.accumulatedFiles[fileInput.id] = [];
    }
    
    // Add new files to accumulated files (avoid duplicates)
    const existingFiles = this.accumulatedFiles[fileInput.id];
    for (let i = 0; i < newFiles.length; i++) {
      const newFile = newFiles[i];
      const isDuplicate = existingFiles.some(existingFile => 
        existingFile.name === newFile.name && 
        existingFile.size === newFile.size && 
        existingFile.lastModified === newFile.lastModified
      );
      
      if (!isDuplicate) {
        existingFiles.push(newFile);
      }
    }
    
    const totalFiles = this.accumulatedFiles[fileInput.id].length;
    
    if (totalFiles > 0) {
      dropzone.classList.add('has-file');
      this.clearFieldError(fileInput);
      
      // Display all accumulated files
      let fileList = '';
      this.accumulatedFiles[fileInput.id].forEach((file, index) => {
        const fileName = file.name;
        const fileSize = this.formatFileSize(file.size);
        fileList += `${index + 1}. ${fileName} <small>(${fileSize})</small><br>`;
      });
      
      infoDiv.innerHTML = `<strong>Selected ${totalFiles} files:</strong><br>${fileList}`;
    }
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  handleFileRemoval(fileInputId) {
    const fileInput = document.getElementById(fileInputId);
    if (!fileInput) {
      return;
    }
    
    const dropzone = fileInput.closest('.proof-dropzone');
    const infoDiv = dropzone.querySelector('.file-selected-info');
    
    if (!dropzone || !infoDiv) {

      return;
    }
    
    // Clear the file input
    fileInput.value = '';
    
    // Clear accumulated files for multiple file inputs
    if (fileInput.hasAttribute('multiple') && fileInput.id === 'proof_final') {
      delete this.accumulatedFiles[fileInputId];
    }
    
    // Update the UI
    dropzone.classList.remove('has-file');
    infoDiv.innerHTML = '';
    
    // Clear any validation errors
    this.clearFieldError(fileInput);

  }

  toggleSectionsOnSuccess() {
    try {
      // Hide playhouse support section
      const playhouseSection = document.querySelector('[data-section-type="playhouse-support"]');
      if (playhouseSection) {
        playhouseSection.classList.add('d-none');
      }
      
      // Hide global content with image section
      const globalContentSection = document.querySelector('[data-section-type="global-content-with-image"]');
      if (globalContentSection) {
        globalContentSection.classList.add('d-none');
      }
      
      // Show your request section
      const yourRequestSection = document.querySelector('[data-section-type="your-request"]');
      if (yourRequestSection) {
        yourRequestSection.classList.remove('d-none');
        
        // Scroll to the success section smoothly
        yourRequestSection.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'start' 
        });
      }
      
    } catch (error) {
      console.error('Error toggling sections:', error);
    }
  }

  isVideoFile(file) {
    // Check MIME type for video files
    if (file.type && file.type.startsWith('video/')) {
      return true;
    }
    
    // Check file extension for common video formats
    const videoExtensions = [
      '.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv', 
      '.m4v', '.3gp', '.ogv', '.ts', '.mts', '.m2ts'
    ];
    
    const fileName = file.name.toLowerCase();
    return videoExtensions.some(ext => fileName.endsWith(ext));
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', function() {
  try {
    new PlayhouseSupport();
  } catch (error) {
    console.error('Error initializing PlayhouseSupport:', error);
  }
});
